import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { Trans } from '@lingui/macro';
import { Typography } from 'antd';

export interface CopyLinkProps {
  copyText?: string;
}

const { Text } = Typography;

export const CopyLink: React.FC<CopyLinkProps> = ({ copyText }) => (
  <Text
    copyable={{
      text: copyText,
      icon: [
        <Link
          key="copy"
          icon={<i className="material-icons">content_copy</i>}
        />,
        <Link
          key="copied"
          icon={
            <div
              style={{
                display: 'inline-block',
                width: 24,
                height: 24,
                lineHeight: 1,
              }}
            >
              <CheckOutlined style={{ fontSize: 18, color: '#52c41a' }} />
            </div>
          }
        />,
      ],
    }}
  />
);

const Link: React.FC<{ icon: React.ReactElement }> = ({ icon }) => (
  <a
    className="b-link -type_underlined g-color-emphasis"
    href=""
    onClick={(event) => event.preventDefault()}
  >
    {icon} <Trans id="general.copy">copy</Trans>
  </a>
);
